module.exports = __webpack_public_path__ + "static/media/16.05bb2c5c.svg";